import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "layout-eoi"
}
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "description"
}
const _hoisted_6 = {
  key: 1,
  class: "description"
}
const _hoisted_7 = {
  key: 2,
  class: "back-dashboard"
}
const _hoisted_8 = {
  key: 3,
  class: "back-map"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 4,
  class: "back-dashboard"
}
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode($setup["HeaderCustomer"], {
          estate: $setup.estate,
          hideAuthButtons: !$setup.isLogged()
        }, null, 8, ["estate", "hideAuthButtons"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo-box" }, [
              _createElementVNode("img", { src: _imports_0 })
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "headline" }, "Contract Information Form Submitted!", -1)),
            ($setup.isLogged() && _ctx.isCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString("You can view all of your active requests by visiting the My Lots section of your LotTrackr dashboard.")))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString("You will receive an email update once your form has been reviewed."))),
            ($setup.isLogged() && _ctx.isCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("a", {
                    class: "button",
                    href: "/customer/lots"
                  }, "My Dashboard", -1)
                ]))]))
              : _createCommentVNode("", true),
            ($setup.isLogged())
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "back",
                    href: `/estate/${$setup.estateId}`
                  }, "Back to masterplan", 8, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "button",
                    href: `/estate/${$setup.estateId}`
                  }, "View masterplan", 8, _hoisted_11)
                ]))
          ])
        ])
      ]))
}